export const metricsIntegrationApiVersion = 'v1';

export const CMI_STATUS_API_POLLING_INTERVAL = 30_000;
